import { render } from "./IconIIIF.vue?vue&type=template&id=c4466730&scoped=true&ts=true"
import script from "./IconIIIF.vue?vue&type=script&lang=ts"
export * from "./IconIIIF.vue?vue&type=script&lang=ts"

import "./IconIIIF.vue?vue&type=style&index=0&id=c4466730&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4466730"]])

export default __exports__